module.exports = __webpack_public_path__ + "static/media/mbl_watch_card.319624ae.svg";